import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// import XLSX from 'xlsx'
// Vue.use(XLSX)


import router from '@/router'
import echarts from 'echarts';
Vue.prototype.$echarts = echarts

// import store from '@/store'

new Vue({
  render: h => h(App),
  router,
  // store
  beforeCreate() {
    Vue.prototype.$bus = this
  }
}).$mount('#app')
